import { NavLink } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ThemeToggle from "./ThemeToggle";

const logoText = "LabArtseener";

const Navbar = () => {
  const [flipping, setFlipping] = useState(false);
  const { i18n } = useTranslation();

  const handleLanguageChange = () => {
    if (flipping) return;
    setFlipping(true);
    setTimeout(() => {
      const newLang = i18n.language === "en" ? "ge" : "en";
      i18n.changeLanguage(newLang);
      localStorage.setItem("language", newLang);
    }, 220);
    setTimeout(() => setFlipping(false), 520);
  };

  return (
    <>
      <nav className="navbar py-3">
        <div className="container navbar-inner">
          <NavLink className="navbar-brand custom-logo" to="/">
            {logoText.split("").map((char, index) => (
              <span
                key={index}
                style={{ animationDelay: `${index * 0.05}s` }}
                className="fade-in-char"
              >
                {char}
              </span>
            ))}
          </NavLink>

          <div className="d-flex align-items-center gap-2">
            <span className="lang-stamp-wrap">
              <button
                type="button"
                className={`lang-stamp ${i18n.language === "en" ? "is-en" : "is-ka"} ${flipping ? "is-flipping" : ""}`}
                onClick={handleLanguageChange}
              >
                {i18n.language === "en" ? "EN" : "GE"}
              </button>
            </span>
            <ThemeToggle />
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
